<template>
  <div class="search-result">
    <el-table
      :data="resourceList"
      size="medium"
      highlight-current-row
      stripe
      empty-text="无搜索结果"
      :row-style="{ height: '30px' }"
    >
      <!-- 高亮 -->
      <el-table-column type="expand" width="1">
        <template slot-scope="slotScope">
          <div style="margin-left:60px;" v-html="slotScope.row.highlight" />
        </template>
      </el-table-column>

      <el-table-column type="index" :index="(pageNum - 1) * pageSize + 1" label="序号" width="80" align="center" />
      <el-table-column prop="resourceTitle" label="题名" align="left">
        <template slot-scope="slotScope">
          <span style="font-weight: bold;">{{ slotScope.row.resourceTitle }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="person" label="责任人" align="left" width="220" />
      <el-table-column prop="edition" label="版本" align="left" width="220" />
      <el-table-column prop="type" label="类型" width="100" align="left" />

      <!-- 操作列 -->
      <el-table-column label="查看" width="200" align="center">
        <template slot-scope="slotScope">
          <router-link :to="{ name: 'ResourceInfo', params: { resId: slotScope.row.resourceId } }" target="_blank">
            <el-button type="primary" size="small" plain icon="el-icon-reading">查看</el-button>
          </router-link>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="page-container">
      <el-pagination
        :total="total"
        :current-page="pageNum"
        :page-size="pageSize"
        :page-sizes="[15]"
        layout="total, prev, pager, next, jumper"
        background
        @current-change="handlePageNumChange"
        @size-change="handlePageSizeChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Result',
  props: {
    resourceList: {
      type: Array,
      default: () => { return [] }
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 15
    }
  },
  methods: {
    /**
     * 处理页码变化
     */
    handlePageNumChange(pageNum) {
      this.pageNum = pageNum
      this.$emit('pageNumChanged', pageNum)
    },

    /**
     * 处理数量变化
     */
    handlePageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.$emit('pageSizeChanged', pageSize)
    }
  }
}
</script>

<style scoped>
.el-table >>> .el-table__expand-column{
  visibility: hidden;
}

</style>
